export const timelinePictograms = {
  accueil: '/brand/timeline/accueil.svg',
  petitDejeuner: '/brand/timeline/petit-dejeuner.svg',
  seminaire: '/brand/timeline/seminaire.svg',
  collation: '/brand/timeline/collation.svg',
  groupeTravail: '/brand/timeline/groupe-travail.svg',
  dejeuner: '/brand/timeline/dejeuner.svg',
  cohesion: '/brand/timeline/cohesion.svg',
} as const;

export const orderedTimelinePictograms = [
  timelinePictograms.accueil,
  timelinePictograms.petitDejeuner,
  timelinePictograms.seminaire,
  timelinePictograms.collation,
  timelinePictograms.groupeTravail,
  timelinePictograms.dejeuner,
  timelinePictograms.cohesion,
] as const;

const timelinePictogramSet = new Set<string>(orderedTimelinePictograms);

export function getOrderedTimelinePictogram(index: number) {
  return orderedTimelinePictograms[index] || orderedTimelinePictograms[orderedTimelinePictograms.length - 1];
}

export function normalizeTimelinePictogram(image: string | undefined, index: number) {
  if (!image || timelinePictogramSet.has(image)) {
    return getOrderedTimelinePictogram(index);
  }

  return image;
}
